import TextField, { TextFieldProps } from '@mui/material/TextField';
import { ChangeEvent, memo, useCallback, KeyboardEvent, ReactElement } from 'react';

export interface CommittingNumberInputProps {
  value: number;
  onValueChange: (value: number | undefined) => void;
  onCommit: () => void;
}

export const CommittingNumberInput = memo(function ({
  value,
  onValueChange,
  onCommit,
  inputProps = {},
  ...restProps
}: CommittingNumberInputProps & TextFieldProps): ReactElement {
  const handleChange = useCallback(
    function (event: ChangeEvent<HTMLInputElement>): void {
      const parsedValue = parseInt(event.target.value);
      onValueChange(isNaN(parsedValue) ? undefined : parsedValue);
    },
    [onValueChange]
  );

  const handleKeyDown = useCallback(
    function (event: KeyboardEvent<HTMLDivElement>): void {
      if (event.key === 'Enter') {
        onCommit();
      }
    },
    [onCommit]
  );

  return (
    <TextField
      {...restProps}
      type='number'
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={onCommit}
      inputProps={{
        ...inputProps,
        step: 'any',
      }}
    />
  );
});
